import { getIsMessageJson } from '../types/guards';
import type { MessageJsonButtons } from '../types/messages';

/** Хук для работы с объектом messageJson в сообщениях */
export const useMessageJson = (messageJson: string | null | MessageJsonButtons) => {
  const messageJsonData = getIsMessageJson(messageJson) ? messageJson : null;
  const messageJsonSelectedValue = messageJsonData ? messageJsonData.selectedValue : '';
  const messageButtons = messageJsonData?.buttons ? messageJsonData.buttons.flat() : [];

  const csatSelectedValueIndex =
    messageJsonSelectedValue && messageButtons
      ? messageButtons.findIndex((button) => button.value === messageJsonSelectedValue)
      : undefined;

  return {
    csatSelectedValueIndex,
    messageButtons,
    messageJsonSelectedValue,
  };
};
